export default __webpack_public_path__ + "static/Entenda0040-16e18bd68009382e8573c1c06b80770c.jpg";